import React from 'react';

export const ListaUsu = () => {
	return [
		{
			fotoUsuario: '',
			nombreUsuario: 'Juan',
			idUsuario: '74320985',
			telefonoUsuario: '633333333',
			correoUsuario: 'usuario123@correro.com',
			telefonoUsuario2: '600300300',
			direccionUsuario: 'C/ Juan 12',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Juan Antonio',
			idUsuario: '74320985',
			telefonoUsuario: '644444444',
			correoUsuario: 'usuario123@correro.com',
			telefonoUsuario2: '600400400',
			direccionUsuario: 'C/ Juan 12',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Roberto',
			idUsuario: '74320985',
			telefonoUsuario: '655555555',
			correoUsuario: 'usuario123@correro.com',
			telefonoUsuario2: '600500500',
			direccionUsuario: 'C/ Juan 12',
		},
		{
			fotoUsuario: '',
			nombreUsuario: 'Alberto',
			idUsuario: '74320985',
			telefonoUsuario: '666666666',
			correoUsuario: 'usuario123@correro.com',
			telefonoUsuario2: '600600600',
			direccionUsuario: 'C/ Juan 12',
		},
	];
};
